module.exports = __webpack_public_path__ + "img/309723.d0055e0a.png";